import React from "react";

export default class HasOptionList extends React.Component {

    onChange = (option,event) => {
        const value = this.getValue(option);
        if (this.props?.onChange) {
            this.props.onChange(value,event);
        }
        this.forceUpdate();
    }

    getLabel(option) {
        return this.props.getLabel ? this.props.getLabel(option) : (option?.label !== undefined ? option?.label : option);
    }

    getValue(option) {
        return this.props.getValue ? this.props.getValue(option) : (option?.value !== undefined ? option?.value : option);
    }

    getUnknownValueLabel(value) {
        return this.props.getUnknownValueLabel ? this.props.getUnknownValueLabel(value) : value;
    }

    getOptions() {
        return this.props.options || [];
    }

    classNameGroup() {
        return "form-group " + (this.props.hidden ? "disappear" : "appear");
    }

    isSameValue(a, b) {
        const epsilon = 0.000001;
        return this.props.isSameValue
            ? this.props.isSameValue(a, b)
            : (
                _.isNumber(a) && _.isNumber(b)
                    ? Math.abs(a - b) < epsilon
                    : a == b
            );
    }

}
